import { render, staticRenderFns } from "./AlternativeEducationForm.vue?vue&type=template&id=b7576eb4&scoped=true"
import script from "./AlternativeEducationForm.vue?vue&type=script&lang=js"
export * from "./AlternativeEducationForm.vue?vue&type=script&lang=js"
import style0 from "./AlternativeEducationForm.vue?vue&type=style&index=0&id=b7576eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7576eb4",
  null
  
)

export default component.exports